import React from "react"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"
import { RiArrowRightLine, RiArrowLeftLine, RiTwitterFill } from "react-icons/ri"

import Layout from "../components/layout"
import SEO from '../components/seo';

const Pagination = (props) => (
  <div className="pagination -post">
    <ul>
        {(props.previous && props.previous.frontmatter.template === 'blog-post') && (
          <li>
              <Link to={props.previous.frontmatter.slug} rel="prev">
                <p><span className="icon -left"><RiArrowLeftLine/></span> Previous</p>
                <span className="page-title">{props.previous.frontmatter.title}</span>
              </Link>
          </li>
        )}
        {(props.next && props.next.frontmatter.template === 'blog-post') && (
          <li>
            <Link to={props.next.frontmatter.slug} rel="next">
              <p>Next <span className="icon -right"><RiArrowRightLine/></span></p>
              <span className="page-title">{props.next.frontmatter.title}</span>
            </Link>
          </li>
        )}
    </ul>
  </div>
)

const Post = ({ data, pageContext }) => {
  const { markdownRemark, site } = data // data.markdownRemark holds your post data
  const { frontmatter, html, excerpt } = markdownRemark
  const Image = frontmatter.featuredImage ? frontmatter.featuredImage.childImageSharp.fluid : ""
  const { previous, next } = pageContext

  let props = {
    previous,
    next
  }

  return (
    <Layout className="page">
      <SEO
        title={frontmatter.title}
        description={frontmatter.description ? frontmatter.description : excerpt}
        image={Image}
        article={true}
      />
      <article className="blog-post">
        <header className="featured-banner">
          <section className="article-header">
            <h1>{frontmatter.title}</h1>
            <time>{frontmatter.date}</time>
          </section>
          {Image ? (
            <Img 
              fluid={Image} 
              objectFit="cover"
              objectPosition="50% 50%"
              alt={frontmatter.title + ' - Featured image'}
              className="featured-image"
            />
          ) : ""}
          <small><center><p>Photo by <Link to={`${frontmatter.photographerLink}`}>{frontmatter.photographerName}</Link> on <Link to={`${frontmatter.photographySiteLink}`}> {frontmatter.photographySite}</Link></p></center></small>
            
          </header>
            
        <br/>
<center>
        <a href={`https://twitter.com/intent/tweet/?text=I%20just%20read%20this%20post&url=https://thunk.technology${frontmatter.slug}&via=${site.siteMetadata.twitterHandle}`} 
   target="_blank" rel="noreferrer">
     <span className="icon -left"><RiTwitterFill/></span>  Share or discuss this blog post with me on Twitter</a>
</center>        
        <div className="blog-post-content" dangerouslySetInnerHTML={{ __html: html }} />
        <br/>
<center>
<a href={`https://twitter.com/intent/tweet/?text=I%20just%20read%20this%20post&url=https://thunk.technology${frontmatter.slug}&via=${site.siteMetadata.twitterHandle}`} 
   target="_blank" rel="noreferrer">
     <span className="icon -left"><RiTwitterFill/></span> Share or discuss this blog post with me on Twitter</a>

</center>
      </article>
      {(previous || next) && (
        <Pagination {...props} />
      )}
    </Layout>
  )
}

export default Post

export const pageQuery = graphql`
  query BlogPostQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      excerpt(pruneLength: 148)
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        slug
        title
        description
        photographerName
        photographerLink
        photographySite
        photographySiteLink
        featuredImage {
          childImageSharp {
            fluid(maxWidth: 1980, maxHeight: 768, quality: 80, srcSetBreakpoints: [350, 700, 1050, 1400]) {
              ...GatsbyImageSharpFluid
              ...GatsbyImageSharpFluidLimitPresentationSize
            }
            sizes {
              src
            }
          }
        }
      }
    }
    site {
      siteMetadata {
        siteUrl
        twitterHandle
      }
    }
  }
`